/**
 * the API gives Euro to pound conversion rate
 * example EUR to GBP is 0.887885 for now.
 * 
 * so in order to get currency value in EUR we need to do 1/0.887885 to get the value 
 */
export const convertEpointsToCurrency = (balance:number, exchangeRate:number): number => {
  const currencyValue = Math.floor(((balance / 200) / exchangeRate) * 100)/100 ;
  return parseFloat(currencyValue.toFixed(2));
};

export const amountWithCurrency = (country: any, value: number): string => {
  let currencyPosition = country?.currencyPosition || 'LEFT';
  let currency = country?.currency || '£';
  let returnValue = currencyPosition?.toLowerCase() === 'right' ?
    `${value > 0 ? new Intl.NumberFormat().format(value) : value.toFixed(2)}${currency}` :
    `${currency}${value > 0 ? new Intl.NumberFormat().format(value) : value.toFixed(2)}`;
  return returnValue;
}